import { AutogenModelOrdersLookupForTenders, AutogenRowOrdersLookupForTenders } from "./autogen/AutogenModelOrdersLookupForTenders";
export class ModelOrdersLookupForTenders extends AutogenModelOrdersLookupForTenders<RowOrdersLookupForTenders> {
	constructor() {
		super(RowOrdersLookupForTenders);
	}
}
export class RowOrdersLookupForTenders extends AutogenRowOrdersLookupForTenders {
}

